var map = {
	"./english.png": "./src/static/img/flag/english.png",
	"./germany.png": "./src/static/img/flag/germany.png",
	"./spain.png": "./src/static/img/flag/spain.png",
	"./turky.png": "./src/static/img/flag/turky.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/static/img/flag sync recursive ^\\.\\/.*\\.png$";